// Тексты подсказок «?» — в одном месте, чтобы сканер и страница инструмента говорили одинаково.

export const HINTS = {
  rail: (
    <>
      Где сейчас позиция каждой группы внутри её диапазона за 26 недель. Слева 0 — самая маленькая позиция за
      полгода, справа 100 — самая большая. Синяя точка — юрлица, оранжевая — физлица. Цветные края 0–20 и 80–100 —
      экстремумы, где Уильямс ищет сделки.
    </>
  ),
  cot: (
    <>
      <b>COT Index юрлиц за 26 недель.</b> (нетто сейчас − минимум за 26 нед.) / (максимум − минимум) × 100.
      80 и выше — юрлица покупают больше обычного, 20 и ниже — продают больше обычного.
    </>
  ),
  cotLong: (
    <>
      COT Index «трёхлетний» (гл. 4: три года = 156 недель, ТЗ M3 v1). Позиции ISS — с января 2023 г., поэтому полное окно
      набирается только к концу 2025 г.; до этого — «—» (истории меньше окна), а не ноль.
    </>
  ),
  willco: (
    <>
      <b>WILLCO</b> — индекс COT не по самой нетто-позиции, а по её доле в открытом интересе, за 26 недель. Убирает
      эффект роста или падения всего рынка. 75 и выше — зона покупки, 90+ — сильный сигнал, 25 и ниже — продажи.
    </>
  ),
  oi: (
    <>
      <b>Индекс открытого интереса</b> за 52 недели: где сейчас общее число открытых контрактов внутри годового
      диапазона. Считается по <b>всему рынку</b>, а не по группе — как в книге. 20 и ниже — рынок «пустой», так
      часто выглядит дно; 80 и выше — толпа уже в рынке, так часто выглядит вершина.
    </>
  ),
  trend: (
    <>
      Наклон 52-недельной средней цены (или правила 39-недельной — переключатель «Тренд»). По методике сделки берут только по тренду: покупки при росте, продажи при
      падении. Сигналы против тренда на графике бледные.
    </>
  ),
  setup: (
    <>
      Балл единого сетапа (гл. 13, 15; ТЗ M19), из 5: +3 за ядро — тренд, юрлица у края диапазона и открытый интерес
      совпали (жирным), +1 за сезонность в ту же сторону, +1 за физлиц на другой стороне — по числу их счетов, а не по
      COT физлиц (на Мосбирже он зеркален COT юрлиц). Балл покупки и балл продажи считаются отдельно, как в ТЗ;
      показывается больший. Без ядра балл — только подтверждения (0–2). Наведите на ячейку — покажет, что выполнено.
    </>
  ),
  spark: <>COT Index юрлиц за последний год. Видно, давно ли группа у края и куда движется.</>,
  net: (
    <>
      <b>Нетто</b> = длинные − короткие позиции группы, в контрактах. Минус — группа в сумме продавец. У физлиц
      ровно противоположное число: на Мосбирже каждый контракт одна группа купила у другой.
    </>
  ),
  share: (
    <>
      Какую часть всего открытого интереса занимают длинные (и короткие) позиции юрлиц. Помогает понять, насколько
      группа доминирует в рынке.
    </>
  ),
  price: (
    <>
      Цена закрытия фьючерса из архива Мосбиржи. По ней считаются тренд и ProGo. <b>Задержка — 1 торговый день</b>:
      архив пополняется после закрытия дня, а сайт обновляется раз в сутки в 00:15 МСК. Сделки сессий выходного дня
      в архиве появляются позже. Поэтому в торговом приложении цена может отличаться.
    </>
  ),
  positions: (
    <>
      Дата последних данных о позициях — итог прошлого торгового дня из статистики Мосбиржи (публикуется на следующий
      день). Сессии выходного дня не учитываются.
    </>
  ),
  journal: (
    <>
      События, когда индикатор впервые вошёл в свою зону. Метка слева — какой индикатор сработал. Бледные строки —
      сигналы против годового тренда (или пока тренд не определён): по методике Уильямса их не торгуют, но показываем, чтобы было видно, что
      копится. «Простой сетап» — тренд и COT в одну сторону. «Полный сетап» — тренд, юрлица и открытый интерес
      совпали сразу.
    </>
  ),
  trendMode: (
    <>
      Тренд для полного сетапа (ТЗ M19). <b>39 н.</b> (по умолчанию) — гл. 15: покупки запрещены, когда 39-недельная
      средняя падает; разрешены, если она растёт, если недельное закрытие выше средней или если средняя плоская
      (изменение меньше 0,1 %), а цены снижаются. Продажи — зеркально. <b>52 н.</b> — гл. 13: вверх, если 52-недельная
      средняя выше прошлой недели, вниз — если ниже, без «плоской» зоны. Простой сетап «за одну минуту» и пометка
      сигналов против тренда всегда считаются по 52 неделям.
    </>
  ),
  cot50: (
    <>
      Фильтр из гл. 10 для краткосрочных покупок: брать их, только когда COT Index юрлиц за 26 недель выше 50. В тесте
      Уильямса по S&amp;P 500 покупки при COT &lt; 50 за 20 лет дали убыток, при COT &gt; 50 — прибыль. Сам по себе не
      сигнал, а «отличная точка старта». В книге это проверка на истории, а не правило входа, поэтому в сделки канона
      он не входит — показан для сведения.
    </>
  ),
  driver: (
    <>
      Гл. 9: важно не то, растёт ли интерес, а кто его меняет. На Мосбирже интерес = лонги юрлиц + лонги физлиц =
      шорты юрлиц + шорты физлиц, поэтому изменение раскладывается по группам точно. В процентах — доля группы в
      изменении (показывается, когда группы двигались в одну сторону). Ниже — какая из шести ситуаций книги
      выполняется сейчас.
    </>
  ),
  seasonal: (
    <>
      Гл. 10, 13: среднее изменение цены для каждой недели года по всей истории, накопленное в кривую «типичного
      года» и сдвинутое к нулю. Подъём кривой — недели, когда цена обычно росла. Подсветка — ближайшие 6 недель. Это
      подтверждение для COT, а не самостоятельный сигнал. Чем больше лет истории цен, тем надёжнее.
    </>
  ),
  trendline: (
    <>
      Гл. 10: вход не по самому сетапу, а по пробою линии тренда после него. Покупка — линия через два последних
      снижающихся краткосрочных максимума, вход при пробое вверх. Продажа — через два растущих минимума, вход при
      пробое вниз. Линии рисуются только когда есть сетап юрлиц в ту же сторону; пунктир — ещё не пробитая линия.
    </>
  ),
  expiry: (
    <>
      Мосбиржа даёт позиции сразу по всем контрактам актива. В последний день старого контракта его позиции закрываются
      или гасятся, и интерес с позициями групп на день-два проваливаются — это техника, а не решение участников.
      <b> Как есть</b> (по умолчанию) — сырые данные, как требует методика. <b>Сглаживать</b>: день экспирации, день до
      и день после берутся по снимку перед этим окном (в недельном режиме неделя экспирации тогда берёт позиции за
      вторник). Для фьючерсов на индексы открытый интерес помечается ненадёжным и в полный сетап не входит (гл. 8). Пунктирные вертикали на графике — даты
      экспираций. Даты официальные — «последний день торгов» из карточки контракта на Мосбирже; если её нет (старые
      контракты), берётся последний день, за который по контракту есть цена.
    </>
  ),
  positions16: (
    <>
      Гл. 12 (ТЗ M16): позиция по входам на пробое линии тренда после сетапа COT или WILLCO, прошедшим тренд-фильтр SMA52. Начальный
      стоп — минимум (максимум) 17 торговых дней до входа без inside-дней (гл. 12). В крупном тренде стоп подтягивается к минимуму (максимуму) 17 торговых дней без inside-дней; после
      выбивания — перевход по максимуму 13 дней. Это учебная модель методики, а не торговая рекомендация.
    </>
  ),
};
